'use strict';

const SELECTORS = {
    levels: '.js-membership-levels-sticky',
    form: '.membership-levels-sticky__form',
    monthlyAmount: '.js-monthly-amount',
    quarterlyAmount: '.js-quarterly-amount',
};

export function init () {
    const levelEls = document.querySelectorAll(SELECTORS.levels);
    const forms = document.querySelectorAll(SELECTORS.form);

    levelEls.forEach(element => {
        const target = document.querySelector(
            element.dataset.donorTarget || '.membership-levels-sticky'
        );

        const defaultDonation = element.dataset.membershipDefaultDonation || 100;
        const visibleClass = element.dataset.membershipToggleClass || 'is-toggled';
        const donationInput = document.querySelector(
            element.dataset.donorInput || '.membership-levels-sticky__input'
        );

        const membershipNameInput = document.querySelector(
            element.dataset.membershipTarget || '.membership-levels-sticky__name'
        );

        element.addEventListener('click', ev => {
            if (target.classList.contains(visibleClass) === false) {
                target.classList.add(visibleClass);
            }

            donationInput.value = defaultDonation.replaceAll(/[^\d]/g, ''); // Strips out any currency styling
            membershipNameInput.value = element.dataset.membershipName;
            ev = new Event('change');
            donationInput.dispatchEvent(ev);
        }, false);
    });

    forms.forEach(form => {
        form.addEventListener('submit', ev => {
            ev.preventDefault();
            const formData = new FormData(form);

            const newURL = new URL(form.dataset.formAction.replace('{Name}', formData.get('membership-name')));
            newURL.searchParams.set('amount', formData.get('membership-amount').replace(/,/g, '')); // Strip out comma separators for thousands etc
            window.location = newURL.toString();

            return false;
        });
    });
}
